import * as angular from "angular";
import * as _ from "lodash"

export class TemplatesService {
  flavor: any;

  constructor() {
  }

  setSiteFlavor(newFlavor) {
    this.flavor = newFlavor;
  }

  resetSiteFlavor() {
    this.flavor = undefined;
  }

  getTemplateUrl(templates) {
    return _.get(templates, this.flavor.id, templates.default);
  }
}

angular
  .module('bringoz.admin.commons')
  .service('templates', TemplatesService);
